import { AppThunk } from '../../../store/reducers';
import { GET, POST, DELETE, PATCH } from '../../../service/HttpMethod';
import { InitialState, Lists, ActionConstant, ActionType } from './types';
import { toastFunction } from '../../../helpers/toastShow';

const initialState: InitialState = {
	usersFetching: true,
	statusCode: 0,
	users: [],
	count: 0,
};

const GetProjectDetailsAction = (data: Lists): ActionType => ({
	type: ActionConstant.GET_USERS,
	data,
});
export const clearUsers = (): ActionType => ({ type: ActionConstant.CLEAR_USERS });
export const clearStatus = (): ActionType => ({ type: ActionConstant.CLEAR_STATUS });

export const getUsers = (data: any = {}): AppThunk => {
	// project details
	const getConfig = {
		url: `users?type=organization`,
		data,
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetProjectDetailsAction(data));
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};
export function createUser(datas: any = {}): AppThunk {
	const postConfig = {
		data: datas,
		url: `users`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await POST(postConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearUsers());
			dispatch(getUsers());
			dispatch(toastFunction('Success', 'User created successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}
export function deleteListUser(id: number): AppThunk {
	const deleteConfig = { url: `users/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(deleteConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearUsers());
			dispatch(getUsers());
			dispatch(toastFunction('Success', 'User deleted successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function changeRole(id = 0, role: string): AppThunk {
	const patchConfig = { url: `users/${id}/role`, data: { role } };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearUsers());
			dispatch(getUsers());
			dispatch(toastFunction('Success', 'Role updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Role update failed', ''));
		}
	};
}
// Change the user office/location
export function changeOffice(id = 0, location: string): AppThunk {
	const patchConfig = { url: `users/${id}/location`, data: { location } };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearUsers());
			dispatch(getUsers());
			dispatch(toastFunction('Success', 'Office updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Office update failed', ''));
		}
	};
}

function userReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_USERS: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				users: [...state.users, ...rows],
				count,
				usersFetching: false,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}

		case ActionConstant.CLEAR_USERS: {
			return {
				...state,
				users: [],
				count: 0,
				usersFetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}

		default:
			return state;
	}
}

export default userReducer;
